import mixpanel from "mixpanel-browser";

import { checkRevisionMethod, generateModificationsList } from "./helpers";
import { getParams } from "@/helpers/getParams";
import moment from "moment";

mixpanel.init(process.env.REACT_APP_MIXPANEL_ID, {
  debug: process.env.REACT_APP_NODE_ENV !== "production" ? true : false,
  track_pageview: false,
});
/// set super props
export const setSuperProps = props => {
  const { clientID, doctorID } = props;
  mixpanel.register({ "Client ID": clientID, "Doctor ID": doctorID });
};
export const StartRevision = (logsData, TPdata, action) => {
  const modifications =
    Object.keys(logsData?.logs)?.length > 0
      ? generateModificationsList(logsData?.logs)
      : [];
  const trackedData = {
    "TS UUID": getParams()?.treatmentSetupsId || "",
    "Revision Method": checkRevisionMethod(logsData),
    Modfications: modifications,
    "No.of steps": Math.max(TPdata?.lowerSteps, TPdata?.upperSteps),
    "Major Version No": TPdata?.version?.toString()?.split(".")?.[0],
    Action: action,
  };
  mixpanel.track("Start Revision", trackedData);
};

export const StartLoadingTime = (startTime, TPdata) => {
  const trackedData = {
    "TS UUID": getParams()?.treatmentSetupsId || "",
    "No.of steps": Math.max(TPdata?.lowerSteps, TPdata?.upperSteps) || "",
    "Number of passive aligners":
      Math.max(
        TPdata?.advancedModules?.passive_aligners?.options
          ?.upperPassiveAligners,
        TPdata?.advancedModules?.passive_aligners?.options
          ?.lowerPassiveAligners,
      ) || "",
    identifier: Date.now() || "",
    "start Time": moment(startTime).format("h:mm A, DD/MM/YYYY"),
  };

  mixpanel.track("Start loading ", trackedData);
};

export const endLoadingTime = (endTime, TPdata) => {
  const trackedData = {
    "TS UUID": getParams()?.treatmentSetupsId || "",
    "No.of steps": Math.max(TPdata?.lowerSteps, TPdata?.upperSteps),
    "Number of passive aligners": Math.max(
      TPdata?.advancedModules?.passive_aligners?.options?.upperPassiveAligners,
      TPdata?.advancedModules?.passive_aligners?.options?.lowerPassiveAligners,
    ),
    identifier: Date.now() || "",
    "loading Time": endTime,
  };

  mixpanel.track("End loading ", trackedData);
};
// Function to track toolbar toggles
export const trackToolbarToggle = (eventName, data) => {
  mixpanel.track(eventName, data);
};

// Function to start a new session
export const startSession = () => {
  const sessionId = localStorage.getItem("mixpanelSessionId");
  mixpanel.track("Viewer session Started", {
    sessionId,
    timestamp: new Date().toISOString(),
  });
};
